import type { ReactNode } from 'react';
import Typography from '@material-ui/core/Typography';
import { TONE_COLORS, tint } from './status';

export function InlineError({ message }: { message: string }) {
  return (
    <Typography
      variant="body2"
      role="alert"
      style={{
        color: TONE_COLORS.error,
        fontSize: 12,
        wordBreak: 'break-word',
        marginBottom: 8,
      }}
    >
      {message}
    </Typography>
  );
}

type Severity = 'error' | 'warning' | 'success' | 'info';

/** Port-like callout: tinted background, subtle tone border, tone text. */
const severityStyle = (severity: Severity) => {
  const color = TONE_COLORS[severity];
  return { bg: tint(color, 8), border: tint(color, 30), color };
};

export function AlertBanner({
  severity,
  title,
  children,
}: {
  severity: Severity;
  title: string;
  children?: ReactNode;
}) {
  const s = severityStyle(severity);
  return (
    <div
      role="alert"
      style={{
        background: s.bg,
        border: `1px solid ${s.border}`,
        borderRadius: 8,
        padding: '8px 12px',
        margin: '8px 0',
        color: s.color,
        fontSize: 13,
      }}
    >
      <strong>{title}</strong>
      {children && <div style={{ marginTop: 4 }}>{children}</div>}
    </div>
  );
}
